import { reportRecoverableError } from '../core/diagnostics'

export function getQueryParam(name: string): string | null {
  return new URL(location.href).searchParams.get(name)
}

export function withQueryParams(url: string, params: Record<string, string | number | boolean | undefined>): string {
  const u = new URL(url, location.href)
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined)
      continue
    u.searchParams.set(key, String(value))
  }
  return u.toString()
}

export function isExternalUrl(url: string): boolean {
  try {
    return new URL(url, location.href).origin !== location.origin
  }
  catch (error: unknown) {
    reportRecoverableError(`invalid URL: ${url}`, error)
    return false
  }
}
